<!-- src/layouts/PublicLayout.vue -->
<template>
  <div>
    <Topbar />
    <Header />
    <search v-if="$route.meta.hideSearch" />
    <main class="page py-3">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Topbar from "@/components/Topbar";
import Header from "@/components/Header";
import Search from "@/components/Search";
import Footer from "@/components/Footer";

export default {
  name: "PublicLayout",
  components: {
    Topbar,
    Header,
    Search,
    Footer,
  },
};
</script>
